import React from 'react';
import { NavLink } from 'react-router-dom';
// import '../../styles/about-page.css';

// Since this component is simple and static, there's no parent container for it.
const HoldingPage = () => {
  return (
        <div>
            <div className="header holding-container">
                <section className="header-textbox">
                    <h5 className="header-title">Oops! This feature is under construction</h5>
                    <p className="header-para">Thanks for your interest in VizKidz, and we&#39;re sorry for the turbulence! <br/>For enquiries contact <a style={{color: 'white', fontWeight: 'bold'}} href="mailto:enquiries@vizkidz.co.uk">enquiries@vizkidz.co.uk</a></p>
                    <NavLink to="/register">
                        <button  className="header-btn">Register Free</button>
                    </NavLink>
                </section>
            </div>
        </div>
    )
}

export default HoldingPage;



// WEBPACK FOOTER //
// ./src/components/common/HoldingPage.js